import Head from "next/head";

import MainLayout from "src/layouts/mainLayout";
import { getIsSsrMobile } from "src/utils/getIsSsrMobile";
import Content from "src/components/pages/facilities/Content";

const Facilities = () => {
	return (
		<>
			<Head>
				<title>تسهیلات</title>
			</Head>
			<Content />
		</>
	);
};
Facilities.Layout = MainLayout;
export default Facilities;

export async function getServerSideProps(context) {
	return {
		props: {
			isSsrMobile: getIsSsrMobile(context)
		}
	}
}